import { z } from "zod";

import { collectionCompletedStateEnum } from "../../enums/collection/collectionCompletedStateEnum";
import { imagesSchema } from "../imagesSchema";

export const baseCollectionSchema = z.object({
  desc: z.string(),
  has_access: z.boolean().optional(),
  has_high_res_illo: z.boolean().optional(),
  has_video: z.boolean().optional(),
  id: z.number(),
  is_album: z.boolean(),
  paid: z.boolean(),
  prayers_count: z.number(),
  sessions: z.string().nullable(),
  short_desc: z.string(),
  style_id: z.number().optional(),
  supertitle: z.string(),
  title: z.string(),
  images: imagesSchema,
  type: z.enum(["challenge", "default"]),
  available_at: z.string().datetime().nullable(),
  ends_at: z.string().datetime().nullable(),
  is_daily: z.boolean().optional(),
  progress: z.float64().nullable(),
  state: z
    .object({
      completed: collectionCompletedStateEnum.nullable(),
    })
    .optional()
    .nullable(),
  is_weekly: z.boolean().optional(),
  users_count: z.number().nullable().optional(),
  place_in_line: z.number().nullable().optional(),
  has_joined: z.boolean().nullable().optional(),
  is_completed: z.boolean().optional().nullable(),
});

export type BaseCollection = z.infer<typeof baseCollectionSchema>;
